export interface GraphYamlData {
  content: string;
  title: string;
  path: string;
}

export interface YAMLContent {
  openapi: string;
  tags: TagElement[];
  paths: PathsObject[];
  components: Components;
}

export interface Components {
  responses: ComponentsResponse[] | null;
  schemas: SchemaType[] | null;
}

export interface ComponentsResponse {
  name: string | null;
  path: string | null;
  description: string;
  content: Content;
}

export interface Content {
  "application/json": ApplicationJSON;
}

export interface ApplicationJSON {
  schema: CommonComponents;
}

export interface CommonComponents {
  $ref: string | null;
  oneOf: Ref[] | null;
}

export interface Ref {
  $ref: string | null;
}

export enum IsInputType {
  Boolean = "boolean",
  Integer = "integer",
  String = "string",
}

export interface LogType {
  type: IsInputType;
  enum?: string[];
}

export interface PathsObject {
  name: string | null;
  get: RequestType | null;
  post: RequestType | null;
  delete: RequestType | null;
  put: RequestType | null;
  patch: RequestType | null;
  summary: string | null;
  parameters?: Parameter[];
}

export interface RequestType {
  tags: Name[];
  summary: string;
  description: string;
  operationId: string;
  parameters?: Parameter[];
  responses: ResponseObject[];
  requestBody?: RequestBody;
}

export interface Parameter {
  in: In;
  name: string;
  description: string;
  example?: boolean | number | string;
  required?: boolean;
  schema: LogType;
}

export enum In {
  Path = "path",
  Query = "query",
}

export interface RequestBody {
  required: boolean;
  content: Content;
  description: string;
}

export interface ResponseObject {
  code: string | null;
  description?: string;
  content?: Content;
  _ref?: string;
  $ref?: string;
  componentResponse: ComponentsResponse | null;
}

export enum Name {
  Jobs = "Jobs",
  Others = "Other",
}

export interface TagElement {
  name: Name;
}

export interface SchemaType {
  name: string | null;
  path: string | null;
  $ref: string | null;
  required: string[];
  type: string | null;
  description: string | null;
  format: string | null;
  example: any | null;
  enum: string[] | null;
  properties: SchemaProperties[] | null;
}

export interface SchemaProperties {
  name: string | null;
  type: string | null;
  format: string | null;
  description: string | null;
  example: string[] | string | null;
  enum: string[] | null;
  items: ItemType | null;
  $ref: string | null;
}

export interface ItemType {
  name: string | null;
  type: string | null;
  $ref: string | null;
}
